import React,{useState,useEffect,useContext} from 'react'
import {Container, Row, Col, Spinner} from "react-bootstrap"
import { InputGroup, InputGroupAddon, Input } from 'reactstrap';
import { Table } from 'reactstrap';
import {CardTitle, CardText } from 'reactstrap';
import {ArrowDownward, GetApp,History, Info, Close, CloudUpload, NavigateBefore, NavigateNext} from '@material-ui/icons';
import axios from "axios"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import {UserContext} from "../Context/UserContext"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import { base_url } from '../../globalConstants';
import Axios from "axios";
// import M from "materialize-css";



export default function List() {
 const EId=useContext(UserContext);
 const ezz = localStorage.getItem("ezzyid")
//  console.log(" ezzyid fromlocal"+ezz)
    const [EzzId,SetEzzId]=useState(ezz);
    
    const [Details,setDetails]=useState([]);
  
    const [modal, setModal] = useState(false);
    const [modalViewDetails, setModalViewDetails] = useState(false);
    const [modalViewHistory, setModalViewHistory] = useState(false);
  const [Id,setId]=useState();
    const toggle = () => setModal(!modal);

    const [orderId, setOrderId] = useState('')
    const [previousPageUrl, setPreviousPageUrl] = useState('')
    const [nextPageUrl, setNextPageUrl] = useState('')
    const toggleUploadFileModal = (tempOrderId) => {
      setOrderId(tempOrderId)
      setModal(!modal);
    }
    const toggleViewDetails = () => setModalViewDetails(!modal);
    const toggleViewHistory = () => setModalViewHistory(!modal);
    const [OrderDetails, setOrderDetails] = useState({});
    const [OrderHistory, setOrderHistory] = useState({});
    const [image, setImage] = useState({upload_location:"",raw:""});
    const [showSpinner, setShowSpinner] = useState()
  
    const externalCloseBtn = <button className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={toggle}>&times;</button>;
    const fetchDetails=async()=>{
        const response=await axios.get(base_url+`boxes_received/?ezz_id=${ezz}`)
        const {data}=response;
        // console.log(data);
        setDetails(data.results);
        setPreviousPageUrl(data.previous);
        setNextPageUrl(data.next);

    }
    useEffect(()=>{
        fetchDetails();
       
    },[])

              
    const [fileUrl, setFileUrl] = useState('')
    const [modalFile, setModalFile] = useState(false);
  const [open, setOpen] = useState(false);
   const [openFile, setOpenFile] = useState(false);
 const toggleFile = () => {
    setModal(!modalFile);
    setOpen(!openFile)
    var elem = document.getElementById(`fileView`)
    // console.log("ELEM", `captureAmount${boxId}`)
    // elem.checked = false
  }

    const downLoadCustomInvoice = async (tempFedexInvoice) => {
   
      var fedexConsolidatedFormData = new FormData()
      fedexConsolidatedFormData.append("invoice", tempFedexInvoice)
  
      await Axios({
        method: "POST",
        url: base_url+`/download_invoice_custom`,
        data: fedexConsolidatedFormData,
        responseType: 'blob'
      }).then(function(response){
     
        const file_url = window.URL.createObjectURL(new Blob([response.data], {type:'application/pdf'}));
        // console.log("fileURL",file_url);
        setFileUrl(file_url)
        
        setModalFile(!modalFile)
       
       // M.toast({html: `File Downloaded.`,classes: "white-text blue rounded"})
      }).catch(function(response){
        console.log("RESPONSE NOT DONE", response);        
        //M.toast({html: `Error while Downloading.`,classes: "white-text red rounded"})
      })
    }
  
  
     const downLoadShippingInvoice = async (tempFedexInvoice) => {
     
      var fedexConsolidatedFormData = new FormData()
      fedexConsolidatedFormData.append("invoice", tempFedexInvoice)
  
      await Axios({
        method: "POST",
        url: base_url+`/download_invoice_shipping`,
        data: fedexConsolidatedFormData,
        responseType: 'blob'
      }).then(function(response){
     
        const file_url = window.URL.createObjectURL(new Blob([response.data], {type:'application/pdf'}));
        // console.log("fileURL",file_url);
        setFileUrl(file_url)
        
        setModalFile(!modalFile)
       
        //M.toast({html: `File Downloaded.`,classes: "white-text blue rounded"})
      }).catch(function(response){
        console.log("RESPONSE NOT DONE", response);        
        //M.toast({html: `Error while Downloading.`,classes: "white-text red rounded"})
      })
    }
  
    const viewOrderDetails = async(tempOrderId) => {
      const response=await axios.get(base_url+`boxes_received/${tempOrderId}`)
      const {data} = response;
      console.log(data);
      setOrderDetails(data);
      toggleViewDetails()

      
      //setOrderDetails(data.results);

      
      // console.log("ORDER DETAILS",tempOrderId)
    }
    const viewOrderHistory = async(tempOrderId) => {
      const response=await axios.get(base_url+`boxes_received/${tempOrderId}`)
      const {data} = response;
      console.log(data);
      setOrderHistory(data);
      toggleViewHistory()

      
      //setOrderDetails(data.results);

      
      // console.log("ORDER DETAILS",tempOrderId)
    }  

    const updateOrderList = async (updatedUrl) => {

      setShowSpinner(true)
      let response_data = []
      var prevUrl 
      var nextUrl 
  
      await axios({
        method: "GET",
        url: updatedUrl
      }).then(function(response){
        setShowSpinner(false)
        // console.log("response",response);
        // console.log("response.data.results",response.data.results);
        response_data = response.data.results
        // context.setState({ updatedOrdersList: response.data.results })
        // console.log("UPDATED ORDELIST",this.state.updatedOrdersList);      
        console.log("UPDATED ORDELIST",response_data);   
        prevUrl = response.data.previous   
        nextUrl = response.data.next   

      }).catch(function(response){
        setShowSpinner(false)
        console.log("response",response);
        console.log("ERROR UPDATING ORDERLIST");
      })
  
      setDetails(response_data)
      setPreviousPageUrl(prevUrl)
      setNextPageUrl(nextUrl)
  
    }

    const handlechangeId=(event)=>{
      setId(event.target.value);
      console.log(Id.EzzId);
    }

    const handleChange = e => {
      if (e.target.files.length) {
        setImage({
          upload_location: URL.createObjectURL(e.target.files[0]),
          raw: e.target.files[0]
        });
      }
    };
	
const handleKeyDownSearch=(e)=>{
    //console.log('orderfilterString',insearch);
    console.log(e.target.value);
    //console.log('orderfilterString',eventKey.target.name);
    //console.log('orderfilterString',eventKey.target.value);
    console.log(e);
    //const ezz = "EZIN00002";
    // const response= axios.get(base_url+`boxes_received/?ezz_id=${ezz}`)
    //     const {data}=response;
    //      console.log(data);
    //      console.log(response);
  let searchUrl = base_url+`boxes_received/?search=${e.target.value}&ezz_id=${ezz}`   
  axios({
    method: 'GET',
    url: searchUrl
  }).then( async (response) =>{
    console.log('succ',response);
    const {data}=response;
    setDetails(data.results);
    setPreviousPageUrl(data.previous);
    setNextPageUrl(data.next);
  }).catch(  (response) =>{
    console.log('fail',response)
   
  })

        //setDetails(data.results);
        //setPreviousPageUrl(data.previous);
        //setNextPageUrl(data.next);
}

    const handleUpload = async e => {

      if(!image.upload_location){
        alert('Please Upload a file first');
        
      }

      e.preventDefault();
      console.log(EzzId);


    
      
      const formData = new FormData();
      formData.append("upload_file", image.raw);
      formData.append("order_id", orderId);
      console.log(image.raw)
      await axios.post(base_url + "invoices/",formData, {
        
        headers: {
          "Content-Type": "multipart/formData"
        },
  
     
        
        
      }).then(res => {
        console.log(res.data);
        
        setImage({upload_location:"", raw:""});
        toast("File Uploaded Successfully");
        setModal(!modal)
      
    })
      .catch(err => {
        // console.log(err);
        console.log(err.response);
        // console.log(err.response.data.upload_file);
        toast.warning('Please upload valid file.');
        if(err.response.data.upload_file)
          toast.warning(err.response.data.upload_file[0]);
      }
      )};

    const handleCancel=()=>{
      setImage({upload_location:"", raw:""});
      setModal(!modal)
    }
    return (
        
        <div>
        <Row>
        <Col xs lg={9}>
        <h4 id="paymentreminder">Order List</h4>
        </Col>
        <Col xs lg={3}>
        <InputGroup size="lg" >
        
        <Input name="insearch" placeholder="Search" onChange={handleKeyDownSearch}/>

      </InputGroup>
        </Col>
        </Row>
        <Row>
          <Col style={{ textAlign: 'center' }}>
            <div>
              {
                showSpinner
                  ?
                  < div className="center">

                    <Spinner animation="grow" variant="primary" size="sm" />
                    <Spinner animation="grow" variant="success" size="sm" />
                    <Spinner animation="grow" variant="warning" size="sm" />
                  </div>
                  :
                  null
              }
            </div>
          </Col>
        </Row>
        <div style={{float:"left", paddingBottom: '5px'}}>
          {
            previousPageUrl
              ? <Button color="info" title="Previous Page" className="teal white-text mr-2" size="sm"
                  onClick={() => updateOrderList(previousPageUrl)} ><NavigateBefore /></Button>
              : <Button color="info" title="Previous Page" className="teal white-text mr-2" size="sm" disabled >
                  <NavigateBefore /></Button>
          }
          {
            nextPageUrl
              ? <Button color="info" title="Next Page" className="teal white-text mr-2" size="sm"
                  onClick={() => updateOrderList(nextPageUrl)}><NavigateNext /></Button>
              : <Button color="info" title="Next Page" className="teal white-text mr-2" size="sm" disabled>
                  <NavigateNext /></Button>
          }          
        </div>
        <div style={{float:"right"}}>
        <h5>Customer ID: {EzzId}</h5>
        </div>

        <Table striped bordered hover>
  <thead>
    <tr>
      <th>Sr. no</th>
      <th>Order No.</th>
      <th>Freight Charge</th>
      <th>Hold Amount</th>
      <th>Outbound No.</th>
      <th>Status</th>
	  <th>Weight</th>
	  <th>Length</th>
	  <th>Breadth</th>
      <th>Height</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    {Details.map((key,index)=>(
        <tr key={key.id}>
        <th scope="row" >{index+1}</th>
        <td>{key.order_id}</td>
        <td>{key.actual_charge}</td>
        <td>{key.product_details.reduce((item, index)=>{
          return item+index.custom_charge
        }, 0)}</td>
        <td><a href={`https://www.fedex.com/fedextrack/?trknbr=${key.outbound_number}`}>{key.outbound_number}</a></td>
        <td>{key.current_status_name}</td>
		<td>{key.weight}</td>
		<td>{key.length}</td>
		<td>{key.breadth}</td>
		<td>{key.height}</td>
        <td>
          <a title="View Details">
            <Info          
              style={{ cursor: "pointer" }}
              onClick={() => viewOrderDetails(key.order_id)} />
            
          </a>{' '}
          <a title="Order History">
            <History            
             style={{ cursor: "pointer" }}
              onClick={() => viewOrderHistory(key.order_id)} />
            
          </a>{' '}
          <a title="Upload Invoice">
            {
              key.current_status_name === "Invoice Missing" 
              ? <CloudUpload               
                  style={{ cursor: "pointer" }}
                  onClick={()=>toggleUploadFileModal(key.order_id)} /> 
              :  "" 
            }
          </a>
          <a title="Download Shipping Invoice">
            {
              key.outbound_number 
              ? <GetApp          
              style={{ cursor: "pointer" }}
              onClick={() => downLoadShippingInvoice(key.box_id)} />
              : ""
            }
          </a>{' '}
          <a title="Download Custome Invoice">
            {
              key.outbound_number 
              ?<ArrowDownward           
              style={{ cursor: "pointer" }}
              onClick={() => downLoadCustomInvoice(key.box_id)} />
              : ""
            }
          </a>{' '}
        </td>  
        </tr>
    ))}
  
  </tbody>
</Table>
<Modal style={{marginTop:"10%"}} isOpen={modal} toggle={toggle} external={externalCloseBtn}>
<ModalHeader>Upload Invoice</ModalHeader>
<ModalBody>

<label htmlFor="upload-button">
{image.upload_location 
? 
  (
    <img src={image.upload_location} alt={orderId} width="300" height="300" />
  ) 
: (
  <>
    <span className="fa-stack fa-2x mt-3 mb-2">
      <i className="fas fa-circle fa-stack-2x" />
      <i className="fas fa-store fa-stack-1x fa-inverse" />
    </span>

    <h5 className="text-left" 
      style={{paddingTop:"10px", backgroundColor:"white",paddingBottom:"10px"
      ,paddingLeft:"5px",paddingRight:"5px", 
      borderColor:"slategray", border:"solid",borderRadius:"10px", width:"300px", height:"70px", marginLeft:"25%"}}>
    Upload File Here...</h5>
    <p>File Format: pdf</p>
    <p>File Size: not more than 2mb</p>
  </>
)}
</label>

<input
type="file"
id="upload-button"
style={{ display: "none" }}
onChange={handleChange}
/>

</ModalBody>
<ModalFooter>
  <Button color="primary" onClick={handleUpload}>Upload</Button>{' '}
  <Button color="secondary" onClick={handleCancel}>Cancel</Button>
</ModalFooter>
</Modal>

<Modal isOpen={modalViewDetails} toggle={toggleViewDetails} size = "lg">
  <div style={{textAlign: 'right', marginTop: '7px', marginRight: '7px'}}>
    <Close onClick={()=>setModalViewDetails(false)} style={{cursor: 'pointer'}} className='' justify='flex-end' />
  </div>
  <ModalHeader>
    <h2>Order Details</h2>
  </ModalHeader>

  <ModalBody>

  <Container fluid="md">
  
  <Row>
    <Table>
      <tbody>
      <tr >
      <th scope="row" style={{ width: "50%" }} >Order No.</th>
      <td style={{ width: "1%" }} >:</td>
      <td>{OrderDetails.order_id}</td>
      </tr>
    
      <tr>
      <th >Customer Id</th>
      <td>:</td>
      <td>{OrderDetails.ezz_id}</td>
      </tr>
      <tr>
      <th >Order Status</th>
      <td>:</td>
      <td>{OrderDetails.current_status_name}</td>
      </tr>
      <tr>
      <th >Inbound No.</th>
      <td>:</td>
      <td>{OrderDetails.inbound_tracking_number}</td>
      </tr>
      <tr>
      <th >Outbound No.</th>
      <td>:</td>
      <td>{OrderDetails.outbound_number}</td>
      </tr>

    </tbody>
    </Table>
    <div style = {{width:"100%"}}>
      <h4>Product Details</h4>
      <table className="table table-hover" id="" >
                  <thead>
                    <tr>
                      <th scope="row" >Sr. No.</th>
                      <th scope="row" >Description</th>
                      <th scope="row" >Quantity</th>
                      <th scope="row" >Price</th>
                      <th scope="row" >Category</th>
                      <th scope="row" >Total Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      OrderDetails.product_details
                      ?
                      OrderDetails.product_details.map((element, index) => (
                            <tr key = {index}>
                              <td>{index + 1}</td>
                              <td>{element.description}</td>
                              <td>{element.quantity}</td>
                              <td>{element.unit_price}</td>
                              <td>{element.category}</td>
                              <td>{(element.unit_price)*(element.quantity)}</td>
                              {/* <td>{parseFloat(parseFloat(element.unit_price)) * (parseInt(element.quantity)).toFixed(2)}</td> */}
                            </tr>
                          ))       
                          : <tr></tr>                           
                        }
                  </tbody>
                  </table>
    </div>
  </Row>
  
</Container>
  </ModalBody>
</Modal>
<Modal isOpen={modalViewHistory} toggle={toggleViewHistory} size = "lg">
  <div style={{textAlign: 'right', marginTop: '7px', marginRight: '7px'}}>
    <Close onClick={()=>setModalViewHistory(false)} style={{cursor: 'pointer'}}  />
  </div>    
  <ModalHeader>
    <h3>Order History</h3>
  </ModalHeader>
  <ModalBody>

  <Container fluid="md">
  
  <Row>
    <Table>
      <tbody>
      <tr >
      <th scope="row" style={{ width: "50%" }} >Shipper No.</th>
      <td style={{ width: "1%" }} >:</td>
      <td>{OrderHistory.shipper_number}</td>
      </tr>
    
      <tr>
      <th >Inbound Tracking No.</th>
      <td>:</td>
      <td>{OrderHistory.inbound_tracking_number}</td>
      </tr>
      <tr>
      <th >Outbound No.</th>
      <td>:</td>
      <td>{OrderHistory.outbound_number}</td>
      </tr>
      <tr>
      <th >Order Date.</th>
      <td>:</td>
      <td>{OrderHistory.order_date}</td>
      </tr>
      <tr>
      <th >Received Date</th>
      <td>:</td>
      <td>{OrderHistory.received_date}</td>      </tr>
      <tr>
      <th >Promo Code</th>
      <td>:</td>
      <td>{OrderHistory.promo_code}</td>      </tr>
      <tr>
      <th >Original Price</th>
      <td>:</td>
      <td>{OrderHistory.original_price}</td>      </tr>

    </tbody>
    </Table>
    
  </Row>
  
</Container>
    

  </ModalBody>
</Modal>
      <Modal id="fileView" className = "fileView" size="lg" isOpen={modalFile} toggle={toggleFile} >
        <ModalBody>



          <iframe name="my-frame" id="my-frame" title="my-frame" src={fileUrl} style={{ width: '100%', height: '100vh' }} ></iframe>

        </ModalBody>
        <ModalFooter>
          <Button outline  onClick={()=>setModalFile(!modalFile)} color="primary" className='mr-2' >Close</Button>
          <Button onClick={()=>{window.frames["my-frame"].print()}} color="primary">Print</Button>
        </ModalFooter>
      </Modal>

<ToastContainer />
        </div>
     
    )
}
